import { useRefinementList } from 'react-instantsearch';

export function MarketFilter(props) {

    const { items, refine } = useRefinementList(props);

    return (
        <ul className="flex items-center flex-nowrap justify-between gap-4 overflow-auto w-full hide-scrollbars">
            {items.map((item) => (
                <label key={item.value} className={"shadow-lg whitespace-nowrap shadow-brand-blue-300/10 pl-4 pr-6 py-3 text-sm rounded-md cursor-pointer flex items-center gap-3 select-none transition-all duration-200 " + (item.isRefined ? 'bg-brand-blue-300 text-white' : 'bg-white/75 text-brand-blue-900')}>
                        <input type="checkbox"
                            className='hidden'
                            value={item.value}
                            checked={item.isRefined}
                            onChange={() => refine(item.value)}
                        />
                        <span className={"rounded-full h-6 w-6 flex items-center justify-center " + (item.isRefined ? 'bg-white/40 text-white' : 'bg-white shadow-md')}>
                            +
                        </span>
                        <span className="item-label">{item.label}</span>
                </label>
            ))}
        </ul>
    )
}


function cx(...classNames) {
    return classNames.filter(Boolean).join(' ');
}
  